__turbopack_context__.v({
  "active": "carousel-module-scss-module__QnX9ha__active",
  "carousel": "carousel-module-scss-module__QnX9ha__carousel",
  "carouselDot": "carousel-module-scss-module__QnX9ha__carouselDot",
  "carouselDots": "carousel-module-scss-module__QnX9ha__carouselDots",
  "carouselItem": "carousel-module-scss-module__QnX9ha__carouselItem",
  "carouselTrack": "carousel-module-scss-module__QnX9ha__carouselTrack",
});
